<div *ngIf="czyZaladowanoDane">
  <div class="container">
    <div class="row pt-4">
      <div class="container-fluid d-none d-md-block">
        <div class="box__scroll py-2">
          <div
            class="box__scroll--top d-flex justify-content-between align-items-center"
          >
            <div
              class="d-flex justify-content-between pt-1 mt-1 align-items-center"
            >
              <div style="display: flex; flex-direction: column">
                <span class="ft__03">Porównywanie danych</span>
                <span class="ft__05">{{ adresLokalizacji }}</span>
              </div>

              <div class="d-flex justify-content-between ml-3 lista-filtrow">
                <a
                  class="przycisk-filtr"
                  *ngFor="let filtr of filtry"
                  [ngClass]="filtr.id == idWybranegoFiltra ? 'active' : ''"
                  (click)="wybierzFiltr(filtr.id)"
                >
                  <i
                    class="fas fa-refresh pen-icon"
                    (click)="
                      pobierzDaneNaPodstawieFiltra(true, true);
                      $event.stopPropagation()
                    "
                    *ngIf="filtr.id == idWybranegoFiltra"
                  ></i>
                  <span
                    class="separator"
                    *ngIf="filtr.id == idWybranegoFiltra"
                  ></span>
                  <span class="nazwa-filtra">{{ filtr.nazwa }}</span>
                  <span class="separator" *ngIf="czyAdmin()"></span>
                  <i
                    class="fas fa-pen pen-icon"
                    (click)="edytujFiltr(filtr.id); $event.stopPropagation()"
                    *ngIf="czyAdmin()"
                  ></i>
                </a>

                <button
                  class="btn__border btn__border--mini px-3 dodaj-filtr"
                  (click)="edytujFiltr()"
                  *ngIf="czyAdmin()"
                >
                  Dodaj filtr
                </button>
              </div>
            </div>

            <div class="input_container">
              <button
                class="btn__clear--filter"
                (click)="wyczyscFiltry()"
                *ngIf="czyPokazacWyczyscFiltry()"
              >
                Wyczyść filtry
              </button>
            </div>
          </div>

          <div class="tableFixHead tableFixHead--3">
            <table
              class="table table--fix2"
              *ngIf="
                czyZaladowanoDaneZFiltra &&
                this.wyszukiwanie.filtry &&
                wyszukiwanie.filtry.kolumnyFiltrowania
              "
            >
              <thead>
                <tr>
                  <th></th>
                  <th
                    *ngFor="
                      let kolumna of wyszukiwanie.filtry.kolumnyFiltrowania
                    "
                  >
                    {{ kolumna.kolumna }}
                    <button
                      class="btn__input--sort--bottom--gray"
                      [ngClass]="pobierzKierunekSortowania(kolumna.kolumna)"
                      (click)="zmienKierunekSortowania(kolumna.kolumna)"
                    ></button>
                    <div class="input_container input_container--mini">
                      <input
                        class="pr-4"
                        type="text"
                        placeholder="Szukaj"
                        [(ngModel)]="kolumna.wartoscSzukaj"
                        (keyup)="filtrujPoTekscie($event, kolumna.kolumna)"
                      />
                      <button
                        class="btn__input--search"
                        *ngIf="
                          !czyPokazacPrzyciskCzyszczeniaFiltru(kolumna.kolumna)
                        "
                      ></button>
                      <button
                        class="btn__input--clear"
                        *ngIf="
                          czyPokazacPrzyciskCzyszczeniaFiltru(kolumna.kolumna)
                        "
                        (click)="wyczyscFiltrKolumny(kolumna.kolumna)"
                      ></button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="fz12" *ngIf="czySaWynikiNaLiscie(spisaneSrodki)">
                <tr
                  *ngFor="let wiersz of spisaneSrodki"
                  class="pointer project-row"
                >
                  <td>
                    <button
                      class="btn__edit"
                      (click)="edytujSrodek(wiersz)"
                      *ngIf="wiersz[kolumnaLiczbaRekordow] == 1"
                    ></button>
                    <button
                      class="btn__next"
                      *ngIf="wiersz[kolumnaLiczbaRekordow] > 1"
                      (click)="wyszukajSrodki(wiersz)"
                    ></button>
                  </td>
                  <td
                    *ngFor="let wartosc of wiersz; index as i"
                    [ngClass]="
                      i == kolumnaId || i == kolumnaLiczbaRekordow ? 'id' : ''
                    "
                  >
                    {{ wartosc }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="ft__03 text-gray text-center my-5 py-5"
              *ngIf="
                !czySaWynikiNaLiscie(spisaneSrodki) &&
                this.idWybranegoFiltra &&
                this.czyZaladowanoDaneZFiltra
              "
            >
              Brak rekordów dla wybranych filtrów.
            </div>
            <div
              class="ft__03 text-gray text-center my-5 py-5"
              *ngIf="!this.idWybranegoFiltra"
            >
              Wybierz filtr, aby wyświetlić dane
            </div>
          </div>
        </div>
        <div
          class="paginate float-right d-flex align-items-center pt-3 pb-2 pt-lg-2 mt-1"
          style="margin-top: -10px !important"
          *ngIf="czySaWynikiNaLiscie(spisaneSrodki)"
        >
          <div>Pokaż wyniki</div>
          <select
            class="paginate__select mx-2"
            name=""
            id=""
            (change)="zmienRozmiarTabeli()"
            [(ngModel)]="rozmiarTabeli"
          >
            <option [ngValue]="35">35</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <div class="px-2">
            {{ pobierzNumerRekorduPoczatek() }}-{{
              pobierzNumerRekorduKoniec()
            }}
            z
            {{ calkowitaLiczbaElementow }}
          </div>
          <div class="d-flex">
            <button
              class="btn__left"
              *ngIf="this.wyszukiwanie.stronicowanie.strona > 1"
              (click)="zmienStrone(-1)"
            ></button>
            <div class="px-2">
              {{ this.wyszukiwanie.stronicowanie.strona }}
            </div>
            <button
              class="btn__right"
              *ngIf="czyJestWiecejRekordow"
              (click)="zmienStrone(1)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <div class="container-fluid d-md-none pb-4">
    <div class="container">
      <div class="row">
        <div style="width: 100%">
          <div class="d-flex justify-content-between pt-4">
            <div class="input_container mb-3 text-right d-flex">
              <div style="display: flex; flex-direction: column">
                <span class="ft__04">Porównywanie danych</span>
                <span class="ft__05">{{ adresLokalizacji }}</span>
              </div>

              <button
                class="btn__search btn__search--mini ml-1"
                *ngIf="!czyPokazanoWyszukiwarkeMobile"
                (click)="pokazWyszukiwarkeMobile(true)"
              ></button>
              <button
                class="btn__input--clear btn__input--clear-search ml-1"
                *ngIf="czyPokazanoWyszukiwarkeMobile"
                (click)="pokazWyszukiwarkeMobile(false)"
              ></button>
            </div>
          </div>

          <div
            class="box__mobile box__mobile--form mb-3"
            *ngIf="czyPokazanoWyszukiwarkeMobile"
          >
            <div
              class="input_container mb-3"
              *ngFor="let kolumna of wyszukiwanie.filtry.kolumnyFiltrowania"
            >
              <input
                class="pr-4"
                type="text"
                placeholder="{{ kolumna.kolumna }}"
                [(ngModel)]="kolumna.wartoscSzukaj"
              />
              <button
                class="btn__input--search"
                *ngIf="!czyPokazacPrzyciskCzyszczeniaFiltru(kolumna.kolumna)"
              ></button>
              <button
                class="btn__input--clear"
                *ngIf="czyPokazacPrzyciskCzyszczeniaFiltru(kolumna.kolumna)"
                (click)="wyczyscFiltrKolumny(kolumna.kolumna)"
              ></button>
            </div>
          </div>
          <button
            class="btn__border mt-4 mb-4"
            (click)="
              pobierzDaneNaPodstawieFiltra(true); pokazWyszukiwarkeMobile(false)
            "
            *ngIf="czyPokazanoWyszukiwarkeMobile"
          >
            Szukaj
          </button>

          <button
            class="btn__clear--filter mt-2 mb-4"
            (click)="wyczyscFiltry(); pokazWyszukiwarkeMobile(false)"
            *ngIf="czyPokazacWyczyscFiltry()"
          >
            Wyczyść filtry
          </button>

          <div class="d-flex filtry-mobile ml-3 lista-filtrow">
            <a
              class="przycisk-filtr"
              *ngFor="let filtr of filtry"
              [ngClass]="filtr.id == idWybranegoFiltra ? 'active' : ''"
              (click)="wybierzFiltr(filtr.id)"
            >
              <span class="nazwa-filtra">{{ filtr.nazwa }}</span>
              <span class="separator" *ngIf="czyAdmin()"></span>
              <i
                class="fas fa-pen pen-icon"
                (click)="edytujFiltr(filtr.id); $event.stopPropagation()"
                *ngIf="czyAdmin()"
              ></i>
            </a>

            <button
              class="btn__border btn__border--mini px-3 dodaj-filtr"
              (click)="edytujFiltr()"
              *ngIf="czyAdmin()"
            >
              Dodaj filtr
            </button>
          </div>

          <div
            class="box__mobile box__mobile--table mb-3 mt-3"
            *ngIf="czySaWynikiNaLiscie(spisaneSrodki)"
          >
            <div class="fixed_table_container">
              <table>
                <tr>
                  <th bgcolor="#BFBFC1"></th>
                  <th
                    *ngFor="
                      let kolumna of wyszukiwanie.filtry.kolumnyFiltrowania
                    "
                  >
                    <div class="d-flex">
                      {{ kolumna.kolumna
                      }}<button
                        class="btn__input--sort--bottom--gray d-inline-block"
                        [ngClass]="pobierzKierunekSortowania(kolumna.kolumna)"
                        (click)="zmienKierunekSortowania(kolumna.kolumna)"
                      ></button>
                    </div>
                  </th>
                </tr>
                <tr
                  *ngFor="let wiersz of spisaneSrodki"
                  class="pointer project-row"
                >
                  <td>
                    <button
                      class="btn__edit"
                      (click)="edytujSrodek(wiersz)"
                      *ngIf="wiersz[kolumnaLiczbaRekordow] == 1"
                    ></button>
                    <button
                      class="btn__next"
                      *ngIf="wiersz[kolumnaLiczbaRekordow] > 1"
                      (click)="wyszukajSrodki(wiersz)"
                    ></button>
                  </td>
                  <td
                    *ngFor="let wartosc of wiersz; index as i"
                    [ngClass]="
                      i == kolumnaId || i == kolumnaLiczbaRekordow ? 'id' : ''
                    "
                  >
                    {{ wartosc }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div
            class="paginate float-right d-flex align-items-center pb-2 pt-lg-4"
            *ngIf="czySaWynikiNaLiscie(spisaneSrodki)"
          >
            <div>Pokaż wyniki</div>
            <select
              class="paginate__select mx-2"
              name=""
              id=""
              (change)="zmienRozmiarTabeli()"
              [(ngModel)]="rozmiarTabeli"
            >
              <option [ngValue]="35">35</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            <div class="px-2">
              {{ pobierzNumerRekorduPoczatek() }}-{{
                pobierzNumerRekorduKoniec()
              }}
              z
              {{ calkowitaLiczbaElementow }}
            </div>
            <div class="d-flex">
              <button
                class="btn__left"
                *ngIf="this.wyszukiwanie.stronicowanie.strona > 1"
                (click)="zmienStrone(-1)"
              ></button>
              <div class="px-2">
                {{ this.wyszukiwanie.stronicowanie.strona }}
              </div>
              <button
                class="btn__right"
                *ngIf="czyJestWiecejRekordow"
                (click)="zmienStrone(1)"
              ></button>
            </div>
          </div>
          <div
            class="ft__03 text-gray text-center py-5"
            *ngIf="
              !czySaWynikiNaLiscie(spisaneSrodki) &&
              this.idWybranegoFiltra &&
              this.czyZaladowanoDaneZFiltra
            "
          >
            Brak rekordów <br />dla wybranych filtrów.
          </div>

          <div
            class="ft__03 text-gray text-center py-5"
            *ngIf="!this.idWybranegoFiltra"
          >
            Wybierz filtr, aby wyświetlić dane
          </div>

          <button class="btn__primary mt-3" (click)="generujArkuszSpisu()">
            Wygeneruj arkusz spisu
          </button>
          <button
            class="btn__border btn__border--mini px-3 mt-3"
            (click)="eksportujDane()"
          >
            Eksportuj dane
          </button>
          <button class="btn__link order-1 order-sm-0" (click)="cofnij()">
            Cofnij
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="py-md-4"></div>
  <div class="bootom__buttons px-4 d-none d-md-block">
    <div
      class="flex-column flex-sm-row d-flex justify-content-between align-items-center container--mw800"
    >
      <button class="btn__link order-1 order-sm-0" (click)="cofnij()">
        Cofnij
      </button>

      <button
        class="btn__border btn__border--mini px-3"
        (click)="eksportujDane()"
      >
        Eksportuj dane
      </button>
      <button
        class="btn__blue order-0 order-sm-1"
        (click)="generujArkuszSpisu()"
      >
        Wygeneruj arkusz spisu
      </button>
    </div>
  </div>
</div>
